/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';

export default function Corners() {
  const sx = {
    container: {
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 'corners',

      width: '100%',
      height: 24,
      display: 'flex',
      justifyContent: 'space-between',

      '> svg': {
        display: 'block',
      },
    },
  };

  return (
    <div sx={sx.container}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="black">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 0H0V24C0 10.7452 10.7451 0 24 0Z"
        />
      </svg>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="black">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 0L2.09815e-06 -2.09815e-06C13.2548 -9.39372e-07 24 10.7452 24 24L24 0Z"
        />
      </svg>
    </div>
  );
}
